import React from 'react';
import './styles.scss';

export const ToastWrap = (props) => <div className="toast__inner-wrapper">{props.children}</div>;

export const ErrorMessage = (props) => (
    <ToastWrap>
        <div className="toast__inner-content">
            <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                    <path d="M0 0h20v20H0z" fill="#9299a2" fillOpacity=".01" />
                    <path
                        d="M10 7.879l-1.19-1.19a1.5 1.5 0 1 0-2.12 2.122L7.878 10l-1.19 1.19a1.5 1.5 0 0 0 2.122 2.12L10 12.122l1.19 1.19a1.5 1.5 0 0 0 2.12-2.122L12.122 10l1.19-1.19a1.5 1.5 0 0 0-2.122-2.12zM20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10z"
                        fill="#e01f19"
                    />
                </g>
            </svg>
            <span className="toast__simple-text">{props.message}</span>
        </div>
    </ToastWrap>
);

export const SuccessMessage = (props) => (
    <ToastWrap>
        <div className="toast__inner-content">
            <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                    <path d="M0 0h20v20H0z" fill="#9299a2" fillOpacity=".01" />
                    <path
                        d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM7.134 9.116a1.25 1.25 0 0 0-1.768 1.768l2.5 2.5c.44.44 1.136.49 1.634.116l5-5a1.25 1.25 0 0 0-1.5-2l-4.133 4.35z"
                        fill="#39b54a"
                    />
                </g>
            </svg>
            <span className="toast__simple-text">{props.message}</span>
        </div>
    </ToastWrap>
);

export const InfoMessage = (props) => (
    <ToastWrap>
        <div className="toast__inner-content">
            <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                    <path d="M0 0h20v20H0z" />
                    <path
                        d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM10 7.5A1.249 1.249 0 1 0 10 5a1.249 1.249 0 1 0 0 2.5zm1.25 6.25V10a1.25 1.25 0 0 0-2.5 0v3.75a1.25 1.25 0 0 0 2.5 0z"
                        fill="#37b"
                    />
                </g>
            </svg>
            <span className="toast__simple-text">{props.message}</span>
        </div>
    </ToastWrap>
);



// WEBPACK FOOTER //
// ./src/components/toast/index.js